import { extendTheme } from '@chakra-ui/react';
// @ts-ignore
import tinycolor from 'tinycolor2';
// @ts-ignore
import media from './media';

const activeLabelStyles = {
  transform: 'scale(0.85) translateY(-24px)',
  opacity: 1,
  height: '35%',
  display: 'flex',
};

export const colors = Object.freeze({
  darkblue: '#102e8e',
  facebook: '#39569a',
  google: '#ea5650',
  persianblue: '#153ebf',
  tomato: '#ff6230',
  gold: '#ffc61f',
  dodgerblue: '#3191d6',
  limegreen: '#75d640',
  crimson: '#dc3545',
  skyblue: '#7fd8ed',
  turquoise: '#3fcecb',
  pink: '#fab7ce',
  steel: '#8092b0',
  mediumpurple: '#8e80b5',
  black: '#060615',
  midnight: '#12123b',
  slategray: '#8e8fa2',
  mischka: '#d5d6de',
  whitesmoke: '#f4f4f7',
  snow: '#fdfdfe',
  white: '#ffffff',
  applyOpacity: (color: string, opacity: number) => tinycolor(color).setAlpha(opacity).toRgbString(),
});

export const PRIMARY_FONT_FAMILY = 'Montserrat, sans-serif';
export const SECONDARY_FONT_FAMILY = 'Open Sans, sans-serif';

export const spacing = Object.freeze({
  TINY: '8px',
  SMALL: '16px',
  BASE: '24px',
  BASE_PLUS: '32px',
  LARGE: '48px',
  XLARGE: '64px',
  XLARGE_PLUS: '96px',
  XXLARGE: '128px',
  sum: function () {
    return [...arguments].reduce((sum, size) => (sum = sum + parseInt(size)), 0).toString() + 'px';
  },
});

export const zIndex = Object.freeze({
  ELEMENTS_CONTAINER: -1,
  CONTENT_BANNER_CONTAINER: 1,
  MODAL_VIDEO_PLAY_ICON: 1,
  SLIDER_CONTAINER: 2,
  NAVIGATION: 1000,
  STICKY_BANNER: 1000,
  NOTIFICATION_AREA: 9999,
  HERO_CONTAINER: 9999,
  MODAL: 10000,
});


export const theme = extendTheme({
  fonts: {
    body: 'Montserrat, sans-serif',
    heading: 'Montserrat, sans-serif',
    // body: 'Montserrat, sans-serif',
  },
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                ...activeLabelStyles,
              },
              'input::placeholder': {
                opacity: 0,
              },
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, .chakra-react-select__wrapper + label': {
              ...activeLabelStyles,
            },
            'input::placeholder': {
              opacity: 1,
            },
            label: {
              top: 0,
              left: 0,
              bottom: 0,
              alignItems: 'center',
              zIndex: 2,
              position: 'absolute',
              backgroundColor: 'white',
              pointerEvents: 'none',
              opacity: 0,
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: 'left top',
            },
          },
        },
      },
    },
    Progress: {
      baseStyle: {
        background: 'gray.300',
        borderRadius: '30px',
        // borderTopLeftRadius: '30px',
        // borderTopRightRadius: '30px',
        // borderBottomLeftRadius: '30px',
        // borderBottomRightRadius: '30px',
      },
      defaultProps: {
        colorScheme: 'limegreen',
        borderRadius: '30px',
        backgroundColor: 'gray.300',
      },
    },
  },
  colors: {
    black: { 500: colors.black, 600: colors.black },
    crimson: { 500: colors.crimson, 600: '#c12a38' },
    darkblue: { 500: colors.darkblue, 600: colors.darkblue },
    dodgerblue: { 500: colors.dodgerblue, 600: colors.dodgerblue },
    facebook: { 500: colors.facebook, 600: colors.facebook },
    gold: { 500: colors.gold, 600: colors.gold },
    google: { 500: colors.google, 600: colors.google },
    limegreen: { 500: colors.limegreen, 600: '#63c52d' },
    mediumpurple: { 500: colors.mediumpurple, 600: colors.mediumpurple },
    midnight: { 500: colors.midnight, 600: colors.midnight },
    mischka: { 500: colors.mischka, 600: colors.mischka },
    persianblue: { 500: colors.persianblue, 600: colors.persianblue },
    pink: { 500: colors.pink, 600: colors.pink },
    skyblue: { 500: colors.skyblue, 600: '#6cbacd' },
    slategray: { 500: colors.slategray, 600: colors.slategray },
    snow: { 500: colors.snow, 600: colors.snow },
    steel: { 500: colors.steel, 600: colors.steel },
    tomato: { 500: colors.tomato, 600: '#ff450d' },
    turquoise: { 500: colors.turquoise, 600: colors.turquoise },
    whitesmoke: { 500: colors.whitesmoke, 600: colors.whitesmoke },
    blue: {
      500: '#102e8e',
      600: '#0833be',
      700: '#05164c',
    },
    stemiBlue: {
      // 50: '#FCE9F0',
      // 100: '#F5C1D4',
      // 200: '#EF9AB8',
      // 300: '#E9729C',
      // 400: '#E34A81',
      500: '#2256ff',
      600: '#1746dd',
      // 700: '#84153D',
      // 800: '#580E28',
      // 900: '#2C0714',
    },
    stemiRed: {
      50: '#FCE9F0',
      100: '#F5C1D4',
      200: '#EF9AB8',
      300: '#E9729C',
      400: '#E34A81',
      500: '#DD2265',
      600: '#B01C51',
      700: '#84153D',
      800: '#580E28',
      900: '#2C0714',
      // 50: '#fef8fa',
      // 100: '#fce9f0',
      // 200: '#f9d8e4',
      // 300: '#f6c6d8',
      // 400: '#f3b2c9',
      // 500: '#ef9ab9',
      // 600: '#e34c82',
      // 700: '#e5568a',
      // 800: '#ba3e6b',
      // 900: '#6e2540',
    },
  },
  shadows: {
    outline: '0 0 0 3px rgba(8, 51, 190, 0.6)',
  },
  textStyles: {
    h1: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 600,
      fontStyle: 'normal',
      fontSretch: 'normal',
      fontSize: '60px',
    },
    h2: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 500,
      fontStyle: 'normal',
      fontSretch: 'normal',
      fontSize: '46px',
      lineHeight: 1.13,
      letterSpacing: '-0.5px',
    },
    h3: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 500,
      fontStyle: 'normal',
      fontSretch: 'normal',
      fontSize: '36px',
      lineHeight: 1.17,
      letterSpacing: '-0.5px',
    },
    h4: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 500,
      fontStyle: 'normal',
      fontSretch: 'normal',
      fontSize: '24px',
      lineHeight: 1.25,
      letterSpacing: 'normal',
    },
    h5: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 500,
      fontStyle: 'normal',
      fontSretch: 'normal',
      fontSize: '15px',
      lineHeight: 1.47,
      letterSpacing: '0.2px',
    },
    h6: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 500,
      fontStyle: 'normal',
      fontSretch: 'normal',
      fontSize: '11px',
      lineHeight: 1.64,
      letterSpacing: '1px',
    },
    body: {
      fontFamily: SECONDARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: 'normal',
      fontSize: '20px',
      lineHeight: 1.5,
    },
    bodyMedium: {
      fontFamily: SECONDARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: 'normal',
      fontSize: '18px',
      lineHeight: 1.67,
    },
    bodySmall: {
      fontFamily: SECONDARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.2px',
      fontSize: '15px',
      lineHeight: 1.6,
    },
    bodyXSmall: {
      fontFamily: SECONDARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '0.2px',
      fontSize: '13px',
      lineHeight: 1.38,
    },
    caption: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 700,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      fontSize: '13px',
      lineHeight: 1.38,
    },
    captionSmall: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 700,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      fontSize: '11px',
      lineHeight: 1.64,
    },
    blockquote: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 600,
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '46px',
      lineHeight: 1.26,
      textAlign: 'center',
    },
    footerSection: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '16px',
      lineHeight: 1.19,
    },
    footerCategory: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '14px',
      lineHeight: 1.36,
    },
    finePrint: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '13px',
      lineHeight: 'normal',
    },
    placeholder: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '14px',
      lineHeight: 'normal',
    },
    label: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '11px',
      lineHeight: 'normal',
    },
    navigationLink: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontWeight: 600,
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '15px',
      lineHeight: 2.13,
      letterSpacing: 'normal',
    },
    textInput: {
      fontFamily: SECONDARY_FONT_FAMILY,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      fontSize: '15px',
      lineHeight: 1.6,
      letterSpacing: 'normal',
    },
    tag: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontSize: '10px',
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
    },
    tabNavigation: {
      fontFamily: PRIMARY_FONT_FAMILY,
      fontSize: '12px',
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStrech: 'normal',
      lineHeight: 1.33,
    },

    //   button: `
    //     font-family: ${PRIMARY_FONT_FAMILY};
    //     font-size: 13px;
    //     font-weight: 400;
    //     line-height: 1.5;
    //   `,
  },
});

export { media };
